import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

export default function ScrollProgress() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const el = document.documentElement;
      const scrolled = el.scrollTop || document.body.scrollTop;
      const total = el.scrollHeight - el.clientHeight;
      setProgress(total > 0 ? (scrolled / total) * 100 : 0);
    };
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '3px',
        width: `${progress}%`,
        background: 'linear-gradient(90deg, #ff6b6b 0%, #ffd93d 50%, #4ecdc4 100%)',
        zIndex: 9999,
        transition: 'width 0.05s linear',
        boxShadow: '0 0 8px rgba(255,107,107,0.6)',
        pointerEvents: 'none',
      }}
    />
  );
}
